import { createFileRoute, redirect } from '@tanstack/react-router';
import { JANE_STREET_PFOF_JOB_BASE_PATH } from '../../../../../../../../features/vendor/jane-street/pfof/job/jane-street-pfof-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/')({
  beforeLoad: () => {
    throw redirect({ to: JANE_STREET_PFOF_JOB_BASE_PATH, replace: true });
  },
  preload: false,
});
